import React from "react";

// RESIZABLE COLUMNS (owner, 2026-10-14: "description column and all rest of
// columns should be resizable ... description column resize should resize the
// input area"). A drag handle on the right edge of each header; every cell's
// input is 100% wide, so the input follows the column. Shared with the shop
// drawings register (owner, 2026-10-19: a wider, resizable name column).
// A column opts in with onHeaderCell: () => ({ width, onResize }).
export default function ResizableTitle({ onResize, width, children, ...rest }) {
  if (!onResize || !width) return <th {...rest}>{children}</th>;
  const start = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const x0 = e.clientX;
    const w0 = width;
    const move = (ev) => onResize(Math.max(60, Math.round(w0 + ev.clientX - x0)));
    const up = () => {
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", up);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    document.addEventListener("mousemove", move);
    document.addEventListener("mouseup", up);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };
  return (
    <th {...rest} style={{ ...(rest.style || {}), position: "relative" }}>
      {children}
      <span
        role="separator" aria-orientation="vertical" title="Drag to resize"
        data-testid="col-resize"
        onMouseDown={start} onClick={(e) => e.stopPropagation()}
        style={{ position: "absolute", right: -4, top: 0, bottom: 0, width: 9, cursor: "col-resize", zIndex: 2 }}
      />
    </th>
  );
}

